// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   CircularProgress, 
//   Typography, 
//   Container, 
//   TextField, 
//   Button, 
//   Paper, 
//   Box, 
//   InputAdornment,
//   Chip
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import GroupIcon from '@mui/icons-material/Group';
// import { withRouter } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { obtenerClientes } from '../../../actions/ClientesAction';
// import TClientes from './TClientes';

// const ClientesPrincipal = (props) => {
//   const mounted = useRef(true);
//   const [Datar, setDatar] = useState([]);
//   const [term, setTerm] = useState('');
//   const [datosCargados, setDatosCargados] = useState(false);
  
//   useEffect(() => {
//     if (mounted.current) {
//       obtenerClientes().then((response) => {
//         if (response.status === 200) {
//           const Data = response.data;
//           setDatar(Data);
//           setDatosCargados(true);
//         } else {
//           setDatosCargados(true);
//         }
//       });
//     }
//     return function cleanup() {
//       mounted.current = false;
//     };
//   }, []);

//   return (
//     <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
//       {/* Header moderno con gradiente */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 3,
//           mb: 3,
//           background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
//           borderRadius: 2,
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <Box
//               sx={{
//                 width: 56,
//                 height: 56,
//                 borderRadius: 2,
//                 background: 'rgba(255,255,255,0.2)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 backdropFilter: 'blur(10px)',
//               }}
//             >
//               <GroupIcon sx={{ fontSize: 32, color: 'white' }} />
//             </Box>
//             <Box>
//               <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
//                 Gestión de Clientes
//               </Typography>
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 <Chip 
//                   label={`${Datar.length} clientes registrados`}
//                   size="small"
//                   sx={{ 
//                     backgroundColor: 'rgba(255,255,255,0.2)', 
//                     color: 'white',
//                     fontWeight: 500,
//                     backdropFilter: 'blur(10px)',
//                   }}
//                 />
//               </Box>
//             </Box>
//           </Box>
          
//           {/* <Button
//             variant="contained"
//             startIcon={<PersonAddIcon />}
//             component={Link}
//             to="/clienteNuevo"
//             sx={{
//               backgroundColor: 'white',
//               color: '#0d47a1',
//               fontWeight: 600,
//               px: 3,
//               py: 1.5,
//               borderRadius: 2,
//               textTransform: 'none',
//               fontSize: '1rem',
//               boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//               '&:hover': {
//                 backgroundColor: 'rgba(255,255,255,0.9)',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
//               },
//               transition: 'all 0.3s ease',
//             }}
//           >
//             Nuevo Cliente
//           </Button> */}
//         </Box>
//       </Paper>

//       {/* Barra de búsqueda moderna */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 3,
//           mb: 3,
//           border: '1px solid',
//           borderColor: 'divider',
//           borderRadius: 2,
//         }}
//       >
//         <TextField
//           fullWidth
//           variant="outlined"
//           placeholder="Buscar por nombre, apellido, CI, RUC o código..."
//           value={term}
//           onChange={(e) => setTerm(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: 'text.secondary' }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             '& .MuiOutlinedInput-root': {
//               borderRadius: 2,
//               backgroundColor: 'background.default',
//               '&:hover': {
//                 backgroundColor: 'action.hover',
//               },
//               '&.Mui-focused': {
//                 backgroundColor: 'background.paper',
//               },
//             },
//           }}
//         />
//       </Paper>

//       {/* Tabla de clientes */}
//       <Paper
//         elevation={0}
//         sx={{
//           border: '1px solid',
//           borderColor: 'divider',
//           borderRadius: 2,
//           overflow: 'hidden',
//         }}
//       >
//         {datosCargados ? (
//           <TClientes
//             rows={Datar}
//             termc={term}
//             history={props.history}
//           />
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               py: 8,
//               gap: 2,
//             }}
//           >
//             <CircularProgress size={48} thickness={4} />
//             <Typography variant="h6" color="text.secondary">
//               Cargando clientes...
//             </Typography>
//           </Box>
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default withRouter(ClientesPrincipal);



import React, { useEffect, useRef, useState } from 'react';

import {
  Alert,
  Box,
  Chip,
  CircularProgress,
  Container,
  InputAdornment,
  LinearProgress,
  Paper,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import GroupIcon from '@mui/icons-material/Group';
import { withRouter } from 'react-router-dom';

import { obtenerClientesPaginado } from '../../../actions/ClientesAction';
import TClientes from './TClientes';

const ClientesPrincipal = (props) => {
  const [clientes, setClientes] = useState([]);
  const [term, setTerm] = useState('');
  const [busqueda, setBusqueda] = useState('');

  // TablePagination de MUI comienza desde la página 0.
  const [pagina, setPagina] = useState(0);
  const [tamanoPagina, setTamanoPagina] = useState(20);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  // Identifica la última solicitud realizada.
  const numeroSolicitud = useRef(0);

  // Espera 400 ms después de escribir para realizar la búsqueda.
  useEffect(() => {
    const temporizador = setTimeout(() => {
      setPagina(0);
      setBusqueda(term.trim());
    }, 400);

    return () => {
      clearTimeout(temporizador);
    };
  }, [term]);

  // Obtiene únicamente la página solicitada.
  useEffect(() => {
    const solicitudActual = ++numeroSolicitud.current;
    let activo = true;

    const cargarClientes = async () => {
      setCargando(true);
      setError('');

      try {
        const response = await obtenerClientesPaginado(
          pagina + 1, // El backend comienza desde la página 1.
          tamanoPagina,
          busqueda
        );

        // Ignora respuestas anteriores.
        if (
          !activo ||
          solicitudActual !== numeroSolicitud.current
        ) {
          return;
        }

        const resultado = response.data || {};

        const filas =
          resultado.data ??
          resultado.Data ??
          [];

        const total =
          resultado.totalRegistros ??
          resultado.TotalRegistros ??
          0;

        setClientes(
          Array.isArray(filas) ? filas : []
        );

        setTotalRegistros(total);
      } catch (err) {
        if (
          !activo ||
          solicitudActual !== numeroSolicitud.current
        ) {
          return;
        }

        console.error(
          'Error al obtener clientes:',
          err
        );

        setClientes([]);
        setTotalRegistros(0);
        setError(
          'No se pudieron cargar los clientes.'
        );
      } finally {
        if (
          activo &&
          solicitudActual === numeroSolicitud.current
        ) {
          setCargando(false);
        }
      }
    };

    cargarClientes();

    return () => {
      activo = false;
    };
  }, [pagina, tamanoPagina, busqueda]);

  const cambiarPagina = (event, nuevaPagina) => {
    setPagina(nuevaPagina);
  };

  const cambiarTamanoPagina = (event) => {
    const nuevoTamano = parseInt(
      event.target.value,
      10
    );

    setTamanoPagina(nuevoTamano);
    setPagina(0);
  };

  return (
    <Container
      maxWidth="xl"
      sx={{ mt: 4, mb: 4 }}
    >
      {/* Encabezado */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background:
            'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                background:
                  'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
              }}
            >
              <GroupIcon
                sx={{
                  fontSize: 32,
                  color: 'white',
                }}
              />
            </Box>

            <Box>
              <Typography
                variant="h4"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Gestión de Clientes
              </Typography>

              <Chip
                label={`${totalRegistros.toLocaleString(
                  'es-PY'
                )} clientes registrados`}
                size="small"
                sx={{
                  backgroundColor:
                    'rgba(255,255,255,0.2)',
                  color: 'white',
                  fontWeight: 500,
                  backdropFilter: 'blur(10px)',
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Buscador */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por nombre, apellido, CI, RUC o código..."
          value={term}
          onChange={(event) =>
            setTerm(event.target.value)
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon
                  sx={{
                    color: 'text.secondary',
                  }}
                />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor:
                'background.default',

              '&:hover': {
                backgroundColor:
                  'action.hover',
              },

              '&.Mui-focused': {
                backgroundColor:
                  'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Tabla */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {cargando && <LinearProgress />}

        {error && (
          <Alert
            severity="error"
            sx={{ m: 2 }}
          >
            {error}
          </Alert>
        )}

        {cargando &&
        clientes.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />

            <Typography color="text.secondary">
              Cargando clientes...
            </Typography>
          </Box>
        ) : (
          <>
           <TClientes
  rows={clientes}
  termc={busqueda}
  paginacionExterna={true}
/>
            <TablePagination
              component="div"
              count={totalRegistros}
              page={pagina}
              rowsPerPage={tamanoPagina}
              onPageChange={cambiarPagina}
              onRowsPerPageChange={
                cambiarTamanoPagina
              }
              rowsPerPageOptions={[
                10,
                20,
                50,
              ]}
              labelRowsPerPage="Clientes por página:"
              labelDisplayedRows={({
                from,
                to,
                count,
              }) =>
                `${from}-${to} de ${count}`
              }
            />
          </>
        )}
      </Paper>
    </Container>
  );
};

export default withRouter(ClientesPrincipal);